<page-headline
    [linkTitle]="pageHeadline.linkTitle"
    [module]="pageHeadline.module"
    [moduleIcon]="pageHeadline.moduleIcon"
    [moduleLink]="pageHeadline.moduleLink"
    [pageTitle]="pageHeadline.pageTitle"
    [linkArray]="pageHeadline.linkArray"
>
</page-headline>
<div class="reporting-page-container">
    <div class="reporting-main-controll-container">
        <div class="main-flter-n-search-area row-layout-track">
            <main-filters (filtersOutput)="applyNewFilters()"></main-filters>
            <div class="reporting-search-area">
                <search-dialog
                    (searchOutput)="searchRows($event)"
                    [searchId]="'reporting'"
                    [searchBoxHeight]="44"
                    [resetSearch]="false"
                >
                </search-dialog>
            </div>
        </div>
    </div>
    <div class="row-layout-track-left-align reporting-displayopt-actionpanel-layout">
        <display-options
            (displayOptionsOutput)="applyDisplayOptions($event)"
            [optionalSummaryList]="optionalSummaryList"
            [showEditButton]="showDisplayOptionsEditButton"
            [extraParameters]="fromRouteDisplayOptionParameters"
            [displayOptionsToReset]="displayOptionsToReset"
            *ngIf="!finAAGModalPage"
        >
        </display-options>
        <div class="hard-date-range" style="margin-right: 15px" *ngIf="finAAGModalPage">
            <span style="font-weight: bold">Date Range: </span>{{ hardDateRange }}
        </div>
        <div class="drildown-export-button" *ngIf="hasData">
            <span
                (click)="exportToExcel()"
                title="{{
                    downloadingExcel
                        ? 'Report is currently being prepared for download. Please wait until the download is complete.'
                        : 'Download Excel'
                }}"
                [hidden]="hideExcelExport"
                [ngClass]="{ 'downloading-excel': downloadingExcel }"
            >
                <mat-icon fontSet="far" fontIcon="fa-file-excel"></mat-icon>
            </span>
            <span
                (click)="exportToPdf()"
                title="Download PDF"
                [hidden]="hidePdfExport"
                class="reporting-pdf-button"
            >
                <mat-icon fontSet="far" fontIcon="fa-file-pdf"></mat-icon>
            </span>
            <span
                (click)="openScheduleBuilder()"
                style="padding-left: 15px"
                title="Schedule Report for Download"
            >
                <mat-icon fontSet="far" fontIcon="fa-clock"></mat-icon>
            </span>
            <span
                (click)="openEditReportDialog()"
                style="padding-left: 15px"
                title="Edit report columns"
            >
                <mat-icon fontSet="far" fontIcon="fa-edit"></mat-icon>
            </span>
        </div>
        <button (click)="testClick()" *ngIf="true" style="height: 30px; visibility: hidden">
            <div style="display: flex">
                <div style="width: 70px">Test export</div>
                <div
                    style="height: 30px; padding-left: 5px; width: 40px"
                    *ngIf="downloadingTestExport"
                >
                    <spin-loader [bounceSize]="'5px'" [type]="'bounce'"></spin-loader>
                </div>
            </div>
        </button>
    </div>

    <div class="reporting-container">
        <custom-mat-table
            [customTableInfo]="customTableInfo"
            [footerObject]="footerObject"
            (contentChanged)="contentChanged($event)"
            (cellClickedEvent)="cellClickedEvent($event)"
            (pageChanged)="pageChangeEvent($event)"
            (sortChanged)="sortChangeEvent($event)"
        ></custom-mat-table>
    </div>
</div>
